import {
  ComponentSingleStyleConfig,
  forwardRef,
  useStyleConfig,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { ComponentStyleProps } from "../../../../../lib/styles/props/component-style-props";
import { CMEditRequestThread } from "../../comment";

export type CMBalloonEditRequestProps = {
  /**
   * メインコメント・返信コメントの編集ボタンのラベル・Ariaラベル。
   * 編集可能とする場合、設定を強く推奨する。
   */
  editButtonLabel?: string;
  /**
   * テキストエリアの最大文字数。
   * 指定しなければ無制限。
   */
  maxLength?: number;

  commentInput: {
    main: {
      placeholder?: string;
      finishButtonLabel: string;
      cancelButtonLabel: string;
      deleteButtonLabel: string;
    };
    reply: {
      placeholder?: string;
      finishButtonLabel: string;
      cancelButtonLabel: string;
      deleteButtonLabel: string;
    };
  };

  deleteConfirmationModal: {
    title: string;
    message?: string;
    deleteButtonLabel: string;
    cancelButtonLabel: string;
  };

  mainComment?: {
    userName: string;
    date: Date;
    comment: string;
  };
  replyComment?: {
    userName: string;
    date: Date;
    comment: string;
  };

  /**
   * 削除確認モーダルの制御に使用する。
   */
  deleteConfirmationModalSettings: {
    isOpen: boolean;
    onOpen: () => void;
    onClose: () => void;
  };

  /**
   * メインコメントが保存・更新されたときのコールバック。
   * この関数が存在すれば、返信コメント編集可能とする。
   *
   * nullに更新する場合、削除を表す。
   */
  onSaveMain?: (value: string | null) => void;
  /**
   * 返信コメントが保存・更新されたときのコールバック。
   * この関数が存在すれば、返信コメント編集可能とする。
   *
   * nullに更新する場合、削除を表す。
   */
  onSaveReply?: (value: string | null) => void;
} & ComponentStyleProps;

/**
 * 修正依頼コメント吹き出しを表示するコンポーネント
 */
export const CMBalloonEditRequest = forwardRef<
  CMBalloonEditRequestProps,
  "div"
>(
  (
    {
      editButtonLabel,
      maxLength,

      commentInput,

      deleteConfirmationModal,

      mainComment,
      replyComment,

      deleteConfirmationModalSettings,
      onSaveMain,
      onSaveReply,

      sx,
      ...rest
    }: CMBalloonEditRequestProps,
    ref,
  ) => {
    const styles = useStyleConfig("CMBalloonEditRequestStyles");

    return (
      <VStack sx={{ ...styles, ...sx }} {...rest} ref={ref}>
        <CMEditRequestThread
          editButtonLabel={editButtonLabel}
          maxLength={maxLength}
          commentInput={commentInput}
          deleteConfirmationModal={deleteConfirmationModal}
          mainComment={mainComment}
          replyComment={replyComment}
          deleteConfirmationModalSettings={deleteConfirmationModalSettings}
          onSaveMain={onSaveMain}
          onSaveReply={onSaveReply}
        />
      </VStack>
    );
  },
);

export const CMBalloonEditRequestStyles: ComponentSingleStyleConfig = {
  baseStyle: {
    minW: "400px",
    w: "400px",
    maxW: "400px",

    pt: "2",
    pr: "3",
    pb: "3",
    pl: "3",

    zIndex: 10,
    alignItems: "stretch",
    bgColor: "orange.100",

    borderWidth: "2px",
    borderColor: "orange.500",
    borderRadius: "md",
    boxShadow: "md",
  },
};
